/**
 * Set of available Requirements that can be set
 */
export enum RequirementType {
  /** Photo verification is required. */
  PhotoVerify = 'photo-verify',
  /** Location selection is required. */
  LocationSelect = 'location-select',
  /** Quiz must have been passed successfully. */
  Quiz = 'quiz',
}

export enum NextStatisticsFilterType {
  Fundraiser = 'fundraiser',
  Team = 'team',
  Campaigns = 'campaign',
  Petition = 'petition_campaign',
  Recruiting = 'recruiting',
}
